module.exports = __webpack_public_path__ + "front/img/edm-btn.c4cfa1b7.png";